'use strict';
var base = require('./base');

module.exports = {
    addToCart: base.addToCart
};